<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ data.user.name }}'s Point</h1>
      <div class="float-right d-inline-block">
        <a class="btn btn-primary shadow-sm text-capitalize" :href="'/point/add?user_id='+data.user.id+'&id='+data.id"><i class="fas fa-plus fa-sm text-white-50"></i> Add </a>
        <a class="btn btn-primary shadow-sm text-capitalize ml-3" :href="'/point/subtract?user_id='+data.user.id+'&id='+data.id"><i class="fas fa-minus fa-sm text-white-50"></i> Subtract </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <overview :data="data"/>
      </div>

      <div class="col-12 mt-3">
        <payment />
      </div>

      <div class="col-12 mt-3">
        <transaction />
      </div>

    </div>
  </div>
</template>

<script>
import overview from '@/pages/point/component/overview'
import payment from '@/pages/point/component/payment'
import transaction from '@/pages/point/component/transaction'

export default {
  components:{
    overview,
    payment,
    transaction,
  },
  data(){
    return {
      data: {
        id: this.$route.query.id,
        user: {
          id: '',
          name: '',
        },
        total: 0,

      }
    }
  },
  async created(){
    
    await this.get_data()
  },
  methods:{
    async get_data(){
      try{
        console.log(base_url+'/point?id='+this.$route.query.id)
        var response = await axios.get(base_url+'/point?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.data.user = response_data.data.user
          this.data.total = response_data.data.total
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
